import React, { useEffect, useState } from "react";
import {
  TextSwitch,
  OptionItem,
} from "../../../../../components/TextSwitch/TextSwitch";
import { FormationTypeEnum } from "../../../../../constants/AppConstants";
import {
  CERTIFICATIONS_LABEL,
  COURSES_LABEL,
  INSTRUCTION_LABEL,
} from "../../../../../constants/Dictionary";
import { CoursesHistory } from "./Courses/CoursesHistory";
import { CertificationsHistory } from "./Certifications/CertificationsHistory";
import { EducationsHistory } from "./Educations/EducationsHistory";
import {
  CollaboratorCmSheet,
  CollaboratorDetails,
} from "../../../../../types/api/collaborators.type";

type FormationHistoryProps = {
  setTextSwitch: (component: React.ReactNode) => void;
  setLink: (component: React.ReactNode) => void;
  collaborator: CollaboratorDetails;
  isMyProfile?: boolean;
  onStatusRefresh: () => void;
  currentCmSheet?: CollaboratorCmSheet;
};

export const FormationHistory = ({
  setTextSwitch,
  setLink: addLink,
  collaborator,
  isMyProfile,
  onStatusRefresh,
  currentCmSheet,
}: FormationHistoryProps) => {
  const formationTypeOptions = [
    { value: FormationTypeEnum.INSTRUCTION, label: INSTRUCTION_LABEL },
    { value: FormationTypeEnum.COURSE, label: COURSES_LABEL },
    { value: FormationTypeEnum.CERTIFICATION, label: CERTIFICATIONS_LABEL },
  ];
  const [selectedFormationType, setSelectedFormationType] = useState<
    OptionItem<FormationTypeEnum>
  >(formationTypeOptions[0]);

  useEffect(() => {
    setTextSwitch(
      <TextSwitch
        selectedOption={selectedFormationType}
        setSelectedOption={setSelectedFormationType}
        options={formationTypeOptions}
      />,
    );
  }, [selectedFormationType]);

  return (
    <div className="content">
      {selectedFormationType.value === FormationTypeEnum.INSTRUCTION && (
        <EducationsHistory
          collaborator={collaborator}
          setLink={addLink}
          isMyProfile={isMyProfile}
          onStatusRefresh={onStatusRefresh}
          currentCmSheet={currentCmSheet}
        />
      )}
      {selectedFormationType.value === FormationTypeEnum.COURSE && (
        <CoursesHistory
          collaborator={collaborator}
          setLink={addLink}
          isMyProfile={isMyProfile}
          onStatusRefresh={onStatusRefresh}
          currentCmSheet={currentCmSheet}
        />
      )}
      {selectedFormationType.value === FormationTypeEnum.CERTIFICATION && (
        <CertificationsHistory
          collaborator={collaborator}
          setLink={addLink}
          isMyProfile={isMyProfile}
          onStatusRefresh={onStatusRefresh}
          currentCmSheet={currentCmSheet}
        />
      )}
    </div>
  );
};
